import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workspaceTabRoute',
  pure: true,
  standalone: true
})
export class WorkspaceTabPipe implements PipeTransform {
  transform(tabPathSegment: string, baseRoute: string[]): string[] {
    if (!baseRoute || !tabPathSegment) {
      return [];
    }
    return [...baseRoute, tabPathSegment];
  }
}
